import { Injectable } from '@angular/core';
import { UserModel } from '../_models/user.model';
import { HttpClient } from '@angular/common/http';
import { CONFIG } from '../_config/config';

@Injectable({
  providedIn: 'root'
})
export class PolicyService {

  constructor(private http: HttpClient) { 
  }

  getPolicy() {
    try {
      return this.http.get('/../assets/config/labviewer_config.json');
    } catch (error) {
      console.log('Error getPolicy');
    }
  }

}
